// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"BoolLabel_checkmark__1f60z","cross":"BoolLabel_cross__LcYb8"};